import { Settings } from '../Settings';
import { BufferPool } from './BufferPool';
var IndexBufferWebGL = /** @class */ (function () {
    function IndexBufferWebGL(gl, numIndices) {
        this.canUnload = true;
        this._gl = gl;
        this._buffer = this._gl.createBuffer();
        this._numIndices = numIndices;
    }
    Object.defineProperty(IndexBufferWebGL, "pool", {
        get: function () {
            if (!Settings.ENABLE_BUFFER_POOLING)
                return null;
            return this._pool || (this._pool = new BufferPool(IndexBufferWebGL));
        },
        enumerable: false,
        configurable: true
    });
    IndexBufferWebGL.create = function (gl, numIndices) {
        if (!Settings.ENABLE_BUFFER_POOLING) {
            return new IndexBufferWebGL(gl, numIndices);
        }
        return this.pool.create(gl, numIndices);
    };
    IndexBufferWebGL.prototype.uploadFromArray = function (array, startOffset, count) {
        this._gl.bindBuffer(this._gl.ELEMENT_ARRAY_BUFFER, this._buffer);
        if (startOffset)
            this._gl.bufferSubData(this._gl.ELEMENT_ARRAY_BUFFER, startOffset * 2, array);
        else
            this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, array, this._gl.STATIC_DRAW);
    };
    IndexBufferWebGL.prototype.uploadFromByteArray = function (data, startOffset, count) {
        this._gl.bindBuffer(this._gl.ELEMENT_ARRAY_BUFFER, this._buffer);
        if (startOffset)
            this._gl.bufferSubData(this._gl.ELEMENT_ARRAY_BUFFER, startOffset * 2, data);
        else
            this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, data, this._gl.STATIC_DRAW);
    };
    IndexBufferWebGL.prototype.dispose = function () {
        if (Settings.ENABLE_BUFFER_POOLING && IndexBufferWebGL.pool.store(this)) {
            return;
        }
        this.unload();
    };
    IndexBufferWebGL.prototype.apply = function (gl, numIndices) {
        this._numIndices = numIndices;
    };
    IndexBufferWebGL.prototype.unload = function () {
        Settings.ENABLE_BUFFER_POOLING && IndexBufferWebGL.pool.remove(this);
        this._gl.deleteBuffer(this._buffer);
    };
    Object.defineProperty(IndexBufferWebGL.prototype, "numIndices", {
        get: function () {
            return this._numIndices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexBufferWebGL.prototype, "glBuffer", {
        get: function () {
            return this._buffer;
        },
        enumerable: false,
        configurable: true
    });
    return IndexBufferWebGL;
}());
export { IndexBufferWebGL };
